<template>
	<div class="service">
		<div class="school-cabinet">
			<div class="school-cabinet_wrapper" v-if="editId == 0">
				<ProductList @edit="editProduct" />
			</div>
			<div v-else>
				<ProductEdit @setGroup="setGroup" @setAmoCRM="setAmoCRM" @save="save" @clearEditProduct="clearEditProduct" :activeProduct="activeProduct" :loading="loading" />
			</div>
		</div>
	</div>
</template>

<script>
  import ProductList from '@/components/ProductList.vue'
  import ProductEdit from '@/components/ProductEdit.vue'
  import { mapGetters, mapActions } from 'vuex';
  export default {
	name: "Service",
	components: {
		ProductList,
		ProductEdit,
	},
	data() {
		return {
			editId: 0,
			amo: null,
			group: null,
			loading: false,
		}
	},
  mounted() {
    this.getGroups();
    this.getCategories();
  },
	methods: {
		...mapActions('products', {
			saveProduct: 'save',
			getProducts: 'getList',
		}),
		...mapActions('groups', {
			getGroups: 'getList',
		}),
		...mapActions('categories', {
			getCategories: 'getList',
		}),
		setAmoCRM(val) {
			this.amo = val;
		},
		setGroup(val) {
			this.group = val;
		},
		editProduct(product) {
			this.editId = product.id;
			this.amo = product.amocrm_category;
			this.group = product.ask_group;
		},
		clearEditProduct() {
			this.editId = 0;
			this.amo = null;
			this.group = null;
		},
		save() {
			this.loading = true;
      let payload = {
        payload: {
          "product": {
            "ask_group_id": this.group?.id,
            "amocrm_category_id": this.amo?.id
          }
        },
        id: this.activeProduct.id,
      }
      this.saveProduct(payload).then(() => {
        this.editId = 0;
        this.amo = null;
        this.group = null;
        this.getProducts().then(() => {
          this.loading = false;
        })
      }).catch((e) => {
        this.$toast.error(e)
        this.loading = false;
      })
		}
	},
	computed: {
		...mapGetters('products', {
			products: 'list',
		}),
		...mapGetters('groups', {
			groups: 'list',
		}),
		...mapGetters('categories', {
			categories: 'list',
		}),
		activeProduct() {
			return this.products.find(p => p.id == this.editId);
		},
	},
  }
</script>



<style>
body {
  overflow-y: scroll;
}

.form-group {
  position: relative;
}

.text-error {
  position: absolute;
  top: 110%;
  left: 0;
  font-size: 14px;
  color: #ff7474;
}

.btn-blue--custom {
  width: 140px;
  height: 44px !important;
}

.breadcrumbs--custom ul {
  flex-wrap: wrap;
}

.breadcrumbs--custom ul li {
  color: #544a4a;
  white-space: nowrap;
}

.breadcrumbs--custom a {
  color: #0033CC;
}

.drop-down-menu {
  position: relative;
  font-size: 15px;
  line-height: 42px;
  border-radius: 5px;
  color: #555555;
  background-color: #ffffff;
  cursor: pointer;
  /* z-index: 20; */
}

.drop-down-menu input {
  padding: 0;
  max-width: 100%;
  font-size: 15px !important;
  color: #555555;
  border: none;
}

.drop-down-menu input:focus {
  outline: none;
}

.drop-down-menu input:disabled {
  background-color: inherit;
}

.filters .drop-down-menu {
  /* max-width: 200px; */
  width: 100%;
  max-width: 100%;
}

@media screen and (max-width: 768px) {
  .filters .drop-down-menu {
    width: 100%;
    max-width: none;
  }
}

.form-control--custom {
  position: absolute;
  width: 100%;
  max-height: 200px;
  overflow-y: scroll;
  outline: none;
  border: 1px solid #E1E1E1;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  box-shadow: none !important;
  top: 100%;
  height: auto !important;
  background: #ffffff;
  z-index: 10;
}

.form-control--custom li {
  padding-left: 15px;
  padding-right: 15px;
  white-space: nowrap;
}

.form-control--custom li:hover {
  background-color: #D2E1F7;
  cursor: pointer;
}

.form-control--instructors {
  height: 230px !important;
  overflow-y: auto;
}

.border-bottom-none {
  border-bottom: none !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.form-control--arrow {
  position: absolute;
  display: inline-block;
  top: 50%;
  right: 14px;
  width: 0;
  height: 0;
  margin-top: -2px;
  border-width: 5px 4px 0 4px;
  border-style: solid;
  border-color: #999999 transparent transparent transparent;
}

.form-control--arrow.rotate {
  transform: rotate(180deg);
}

.school-cabinet_info-table-text--custom {
  white-space: nowrap;
}

.opacity {
  opacity: .6;
  pointer-events: none;
}

.page-link:focus {
  box-shadow: none !important;
}

.page-item.disabled:first-of-type .page-link,
.page-item.disabled:last-of-type .page-link {
  background-color: #e4e4e4;
}

.page-item:first-of-type .page-link::before,
.page-item:last-of-type .page-link::before {
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  font-size: 15px;
}

.fade-enter-active, .fade-leave-active {
  transition: .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}

.fade--top-enter-active, .fade--top-leave-active {
  transition: .4s;
  transform: translateY(0px);
}
.fade--top-enter, .fade--top-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
  transform: translateY(-5px);
}

.reset-filters {
  padding: 0;
  font-size: inherit;
  line-height: 14px;
  border: none;
  color: #868686;
  background-color: transparent;
  text-decoration: underline;
  cursor: pointer;
}

@media screen and (max-width: 1200px) {
  .filters-item--100 {
    width: 100%;
    text-align: center;
  }
}

.site-body {
  overflow: visible !important;
}

.wrapper-for-spinner {
  position: relative;
}

.wrapper-for-spinner__spinner {
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
}

.width-23 {
  width: 23px;
}

.vs__selected-options {
  max-width: 100%;
}

.vs__search,
.vs__search:focus {
  text-overflow: ellipsis;
}

.vs--single .vs__selected {
  width: 90% !important;
}

.account-content {
  transition: .3s ease-in-out;
}

@media screen and (max-width: 400px) {
  .school-cabinet_card-button {
    width: 120px !important;
  }
}
</style>
